module.exports = __webpack_public_path__ + "static/img/accountant-General.85ddbda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/accountant-General.png
// module id = nNfP
// module chunks = 1